import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { NotFoundErrorPageContentSelector } from './NotFoundErrorPageContentSelector';
import { HeroTeaserDto } from '@cp-es/common';
import { fetchNotFoundError } from './NotFoundErrorPageSlice';

export function useNotFoundErrorPage(): AbstractContentState<HeroTeaserDto> {
    return useCmsContent(fetchNotFoundError, NotFoundErrorPageContentSelector);
}
